import {
  format,
  formatDistanceToNow,
  formatDistanceToNowStrict,
  fromUnixTime,
} from 'date-fns';
import { ptBR, enUS } from 'date-fns/locale';
import i18n from 'dashboard/i18n/instance';

// Tempo relativo localizado (ex.: "há 2 horas" / "2 hours ago"). Ao contrario
// de `dynamicTime` (shared/helpers/timeHelper), respeita o idioma atual da UI
// via o locale do date-fns. Mantemos separado pra nao quebrar o `shortTimestamp`,
// que depende das strings em ingles.
const DATE_FNS_LOCALES = { pt_BR: ptBR, pt: ptBR };

// Ordem dia/mês por locale — em inglês o mês vem antes.
const TIMESTAMP_FORMATS = {
  pt_BR: "d 'de' MMM 'de' yyyy, HH:mm",
  pt: "d 'de' MMM 'de' yyyy, HH:mm",
  default: 'MMM d, yyyy, HH:mm',
};

const currentLocale = () => DATE_FNS_LOCALES[i18n.global.locale.value] || enUS;

// Pra quem formata com `format`/`startOfWeek` do date-fns fora daqui (o
// calendário de agendamentos): o locale do idioma da UI, uma definição só.
export const dateFnsLocale = () => currentLocale();

export const timeAgo = unixTimestamp =>
  formatDistanceToNow(fromUnixTime(unixTimestamp), {
    addSuffix: true,
    locale: currentLocale(),
  });

// Mesma informação, sem a moldura da frase: "1 mês" em vez de "há cerca de 1
// mês", "4 dias" em vez de "há 4 dias". Existe pra caber em linha estreita
// (card do grafo de versões, ~75px pro valor) — a versão com sufixo pedia
// 102px e truncava justamente a data, que é o dado da linha. Use só onde o
// rótulo ao lado já diz que é passado ("Criada", "Aprovada"); em texto
// corrido, `timeAgo`.
export const timeAgoCompact = unixTimestamp =>
  formatDistanceToNowStrict(fromUnixTime(unixTimestamp), {
    locale: currentLocale(),
  });

// Com sufixo mas SEM o "cerca de": "em 3 horas", "há 2 dias". Pra coluna
// estreita onde a moldura da frase importa (futuro × passado) e o "cerca de"
// só ocupa espaço — a agenda de agendamentos, com a hora exata logo acima.
export const timeAgoStrict = unixTimestamp =>
  formatDistanceToNowStrict(fromUnixTime(unixTimestamp), {
    addSuffix: true,
    locale: currentLocale(),
  });

// Data e hora exatas — o que o tempo relativo nunca diz. Pra tooltip/title de
// um relativo, não pra substituí-lo: "há 4 dias" se lê de relance,
// "26 de ago de 2026, 14:32" responde "que dia, exatamente?".
export const absoluteTime = unixTimestamp =>
  format(
    fromUnixTime(unixTimestamp),
    TIMESTAMP_FORMATS[i18n.global.locale.value] || TIMESTAMP_FORMATS.default,
    {
      locale: currentLocale(),
    }
  );
